import {Injectable} from '@angular/core'
import {HttpClient} from '@angular/common/http'
import {Category, Message} from '../interfaces'
import {Observable} from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {
  constructor(private http: HttpClient) {
  }

  fetch(): Observable<Category[]> {
    return this.http.get<Category[]>('/api/category')
  }

  getById(id: string): Observable<Category> {
    return this.http.get<Category>(`/api/category/${id}`)
  }

  getBySecondName(secondName: string): Observable<Category[]> {
    return this.http.get<Category[]>(`api/category/${secondName}`)
  }

  create(name: string, secondName: string, image?: File): Observable<Category> {
    const fd = new FormData()

    if (image) {
      fd.append('image', image, image.name)
    }
    fd.append('name', name)
    fd.append('secondName', secondName)

    return this.http.post<Category>('/api/category', fd)
  }

  update(id: string, name: string, secondName: string, image?: File): Observable<Category> {
    const fd = new FormData()

    if (image) {
      fd.append('image', image, image.name)
    }
    fd.append('name', name)
    fd.append('secondName', secondName)

    return this.http.patch<Category>(`/api/category/${id}`, fd)
  }

  delete(id: string): Observable<Message> {
    return this.http.delete<Message>(`/api/category/${id}`)
  }
}
